import axios from "@/libs/api.request";
// 获取列表
export const getHwBillBranch = data => {
  return axios.request({
    url: "/finance/branch/overseas/bill/list",
    method: "post",
    data
  });
};
// 明细列表
export const getDetails = data => {
  return axios.request({
    url: `/finance/branch/overseas/bill/read/${data.id}`,
    method: "post",
    data
  });
};
// 更新账单
export const updateHwBill = data => {
  return axios.request({
    url: `/finance/branch/overseas/bill/update/${data.id}`,
    method: "post",
    data
  });
};
// 删除账单
export const delHwBill = id => {
  return axios.request({
    url: `/finance/branch/overseas/bill/del/${id}`,
    method: "post"
  });
};
// 确认账单
export const confirmBill = id => {
  return axios.request({
    url: `/finance/branch/overseas/bill/confirm/${id}`,
    method: "post"
  });
};
// 核销账单
export const auditBill = data => {
  return axios.request({
    url: `/finance/branch/overseas/bill/audit/${data.id}`,
    method: "post",
    data
  });
};
// 重新计算
export const resetHwAmount = id => {
  return axios.request({
    url: `/finance/branch/overseas/bill/resetAmount/${id}`,
    method: "post"
  });
};
// 追加
export const appendCnbNo = data => {
  return axios.request({
    url: `/finance/branch/overseas/bill/append/${data.id}`,
    method: "post",
    data
  });
};

// 挂起
export const hangBill = data => {
  return axios.request({
    url: `/finance/branch/overseas/bill/removeOut/${data.id}`,
    method: "post",
    data
  });
};

// 删除
export const deleteDetails = data => {
  return axios.request({
    url: `/finance/branch/overseas/bill/deleteOut/${data.id}`,
    method: "post",
    data
  });
};

// 导出
export const exportDetails = id => {
  return axios.request({
    url: `/finance/branch/overseas/bill/exportDetail/${id}`,
    method: "post",
  });
};



